import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./EmployeeLogin.css";
import fetchBase from "../utils/fetchBase";

export default function EmployeeLogin() {
    const [phone, setPhone] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [isExistingUser, setIsExistingUser] = useState(false);
    const [error, setError] = useState("");
    const [isNewUser, setIsNewUser] = useState(false);
    const [success, setSuccess] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const shouldRequestLocation = phone.replace(/\D/g, "").length === 10 && isExistingUser;

        if (shouldRequestLocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    localStorage.setItem("latitude", position.coords.latitude);
                    localStorage.setItem("longitude", position.coords.longitude);
                },
                (error) => {
                    console.error("Geolocation error:", error);
                }
            );
        }
    }, [phone, isExistingUser]);

    const handlePhoneChange = (e) => {
        let value = e.target.value;

        value = value.replace(/\D/g, "");
        if (value.length > 10) value = value.slice(0, 10);

        if (value.length >= 7) {
            value = `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6)}`;
        } else if (value.length >= 4) {
            value = `(${value.slice(0, 3)}) ${value.slice(3)}`;
        } else if (value.length >= 1) {
            value = `(${value}`;
        }

        setPhone(value);
    };

    const handlePhoneSubmit = async (e) => {
        e.preventDefault();
        setError("");

        try {

            console.log("SENDING PHONE:", phone);
            const response = await fetch(`${fetchBase}/api/employee/check-phone`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },


                body: JSON.stringify({ phone }),
            });

            let data = {};
            const text = await response.text();
            try {
                data = JSON.parse(text);
            } catch (e) {
                console.warn("Empty or invalid JSON response body. Raw text:", text);
            }

            console.log("Phone check response:", data);

            if (response.ok) {
                setIsNewUser(data.isNewUser);
                setIsExistingUser(true);
            } else {
                setError(data.message || "Phone number not recognized.");
            }
        } catch (err) {
            console.error("Phone check error:", err);
            setError("Server error. Please try again later.");
        }
    };

    const handlePasswordSubmit = async (e) => {
        e.preventDefault();
        setError("");

        if (isNewUser && password !== confirmPassword) {
            setError("Passwords do not match.");
            return;
        }

        const endpoint = isNewUser
            ? "/api/employee/set-password"
            : "/api/employee/login";

        try {
            console.log("Submitting to:", endpoint);
            console.log("Submitted phone:", phone);


            const response = await fetch(`${fetchBase}${endpoint}`, {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify({ phone, password }),
                        });

            let data = {};
            const text = await response.text();
            try {
                data = JSON.parse(text);
            } catch (e) {
                console.warn("Empty or invalid JSON response body. Raw text:", text);
            }

            console.log("Login/set-password response:", data);

            if (response.ok) {
                const email = data.email || "";
                const id = data.id || "";
              //  const authHeader = "Basic " + btoa(`${phone}:${password}`);
              //  console.log("Generated auth header:", authHeader);

                localStorage.setItem("employee_email", email);
                localStorage.setItem("employee_phone", phone);
                localStorage.setItem("jwt_token", data.token);
                localStorage.setItem("employee_id", id);
                localStorage.setItem("role", "employee");


                if (isNewUser) {
                    setSuccess(true);
                    setTimeout(() => navigate("/employee/dashboard"), 2000);
                    } else {
                        navigate("/employee/dashboard");
                    }
            } else {
                console.error("Auth error:", text);
                setError(data.message || text || "Login failed.");
            }
        } catch (err) {
            console.error("Password submit error:", err);
            setError("Server error. Please try again later.");
        }


    };

    return (
        <div className="login-page">
            <div className="login-card">
                {!success ? (
                    <>
                        <h2 className="title">Employee Login</h2>
                        {!isExistingUser ? (
                            <form onSubmit={handlePhoneSubmit} className="login-form">
                                <input
                                    type="text"
                                    placeholder="Phone Number"
                                    value={phone}
                                    onChange={handlePhoneChange}
                                    className="input"
                                    required
                                />
                                <button type="submit" className="submit-button">Next</button>
                                {error && <p className="error-message">{error}</p>}
                            </form>
                        ) : (
                            <form onSubmit={handlePasswordSubmit} className="login-form">
                                <div style={{ position: "relative" }}>
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        placeholder={isNewUser ? "Create Password" : "Enter Password"}
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        className="input"
                                        required
                                        style={{ paddingRight: "40px" }}
                                    />
                                    <button
                                        type="button"
                                        onClick={() => setShowPassword(prev => !prev)}
                                        style={{
                                            position: "absolute",
                                            right: "10px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            background: "none",
                                            border: "none",
                                            cursor: "pointer",
                                            padding: 0,
                                            color: "#6e6e73",
                                            display: "flex",
                                            alignItems: "center"
                                        }}
                                        tabIndex={-1}
                                    >
                                        {showPassword ? (
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94"/>
                                                <path d="M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19"/>
                                                <line x1="1" y1="1" x2="23" y2="23"/>
                                            </svg>
                                        ) : (
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                                                <circle cx="12" cy="12" r="3"/>
                                            </svg>
                                        )}
                                    </button>
                                </div>
                                {isNewUser && (
                                    <div style={{ position: "relative" }}>
                                        <input
                                            type={showConfirmPassword ? "text" : "password"}
                                            placeholder="Confirm Password"
                                            value={confirmPassword}
                                            onChange={(e) => setConfirmPassword(e.target.value)}
                                            className="input"
                                            required
                                            style={{ paddingRight: "40px" }}
                                        />
                                        <button
                                            type="button"
                                            onClick={() => setShowConfirmPassword(prev => !prev)}
                                            style={{
                                                position: "absolute",
                                                right: "10px",
                                                top: "50%",
                                                transform: "translateY(-50%)",
                                                background: "none",
                                                border: "none",
                                                cursor: "pointer",
                                                padding: 0,
                                                color: "#6e6e73",
                                                display: "flex",
                                                alignItems: "center"
                                            }}
                                            tabIndex={-1}
                                        >
                                            {showConfirmPassword ? (
                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                    <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94"/>
                                                    <path d="M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19"/>
                                                    <line x1="1" y1="1" x2="23" y2="23"/>
                                                </svg>
                                            ) : (
                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                                                    <circle cx="12" cy="12" r="3"/>
                                                </svg>
                                            )}
                                        </button>
                                    </div>
                                )}
                                {isNewUser && confirmPassword && (
                                    password === confirmPassword ? (
                                        <p style={{ color: 'lightgreen', fontSize: '0.9rem' }}>
                                            Passwords match ✓
                                        </p>
                                    ) : (
                                        <p className="error-message">Passwords do not match</p>
                                    )
                                )}
                                <button type="submit" className="submit-button">
                                    {isNewUser ? "Create Account & Login" : "Login"}
                                </button>
                                {error && <p className="error-message">{error}</p>}
                            </form>
                        )}
                    </>
                ) : (
                    <div className="success-container">
                        <div className="checkmark-circle">✔</div>
                        <p>Password created successfully!</p>
                    </div>
                )}
            </div>
        </div>
    );
}
